import * as Sentry from '@sentry/browser';

import { Who5Options, Who5Values } from '../../components/Clients/FilterSection';
import { BASE_PAGINATION_VARIABLES, PageInfo } from './constants';
import { QueryClientsArgs } from '../../generated/webapp_gql';

export const buildWho5Query = (who5Filter) => {
  if (who5Filter.length === 0) {
    return {};
  }

  const queryObj = {};
  const lastWho5DateArray: string[] = [];

  // the order of the if statements matter here as we want the strings to be in order
  if (who5Filter.includes(Who5Options.Past7Days)) {
    lastWho5DateArray.push(Who5Values.Past7Days);
  }

  if (who5Filter.includes(Who5Options.WithinAMonth)) {
    lastWho5DateArray.push(Who5Values.WithinAMonth);
  }

  if (who5Filter.includes(Who5Options.MoreThanAMonth)) {
    lastWho5DateArray.push(Who5Values.MoreThanAMonth);
  }

  if (who5Filter.includes(Who5Options.NotCompleted)) {
    lastWho5DateArray.push(Who5Values.NotCompleted);
  }

  queryObj['lastWho5Date'] = lastWho5DateArray.join(',');

  return queryObj;
};

export const getVariablesFromPageChange = ({
  currentPageCursors,
  lastPage,
  pageNumber,
  pageSize,
  previousPageNumber,
}: {
  currentPageCursors: PageInfo;
  lastPage: number;
  pageNumber: number;
  pageSize: number;
  previousPageNumber: number;
}): QueryClientsArgs => {
  const variables = { ...BASE_PAGINATION_VARIABLES };

  switch (pageNumber) {
    case lastPage:
      variables.last = pageSize;
      break;
    case 1:
      variables.first = pageSize;
      break;
    case previousPageNumber - 1:
      variables.last = pageSize;
      variables.before = currentPageCursors.startCursor;
      break;
    case previousPageNumber + 1:
      variables.first = pageSize;
      variables.after = currentPageCursors.endCursor;
      break;
    default:
      Sentry.captureMessage(
        `Unexpected pagination case on the ClientsPage: ${previousPageNumber} => ${pageNumber}`,
      );
  }

  return variables;
};
